import { Note } from '~models';
import { getField, updateField } from 'vuex-map-fields';
import { notes } from '~api';
import { Handler } from '~services';

const SET_NOTE = 'SET_NOTE';
const RESET_NOTE = 'RESET_NOTE';
const TRIGGER_MODAL = 'TRIGGER_MODAL';
const LOADING = 'LOADING';

const state = {
    note: { ...new Note() },
    showModal: false,
    isLoading: false
};

const actions = {
    /**
     * Reset note state
     * @param {function} commit
     */
    resetNote({ commit }) {
        commit(RESET_NOTE);
        commit(TRIGGER_MODAL);
    },

    /**
     * Create Note
     * @param {function} commit
     */
    async createNote({ commit, state, dispatch }) {
        commit(LOADING);

        const resp = await notes.createNote(state.note);

        if (resp.ok) {
            commit(RESET_NOTE);
            commit(TRIGGER_MODAL);
        }

        if (resp.ok) dispatch('records/getList', null, { root: true });

        Handler.handleResponse(resp);

        commit(LOADING);
    },

    /**
     * Update Note
     * @param {function} commit
     */
    async updateNote({ commit, state, dispatch }) {
        commit(LOADING);
        const { title, body, id } = state.note;
        const resp = await notes.updateNote({ title, body }, id);

        if (resp.ok) {
            commit(RESET_NOTE);
            commit(TRIGGER_MODAL);
            if (resp.ok) dispatch('records/getList', null, { root: true });
        }

        Handler.handleResponse(resp);

        commit(LOADING);
    },

    /**
     * Trigger modal window open/close
     * @param {function} commit
     */
    triggerModal({ commit }) {
        commit(TRIGGER_MODAL);
    },

    /**
     * Set note for editing
     * @param {function} commit
     * @param {object} data
     */
    setNote({ commit }, params) {
        const { title, body, id, noteType } = params;
        commit(SET_NOTE, { title, body, id, noteType });
        commit(TRIGGER_MODAL);
    },
    /**
     * Set note for editing
     * @param {function} commit
     * @param {object} data
     */
    async deleteNote({ dispatch }, id) {
        const resp = await notes.deleteNote(id);

        if (resp.ok) dispatch('records/getList', null, { root: true });
        Handler.handleResponse(resp);
    }
};

const mutations = {
    // Add the `updateField` mutation to the
    // `mutations` of your Vuex store instance.
    updateField,
    [SET_NOTE](state, data) {
        state.note = data;
    },
    [RESET_NOTE](state) {
        state.note = { ...new Note() };
    },
    [TRIGGER_MODAL](state) {
        state.showModal = !state.showModal;
    },
    [LOADING](state) {
        state.isLoading = !state.isLoading;
    }
};

const getters = {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
    isLoading: state => state.isLoading,
    note: state => state.note,
    showModal: state => state.showModal
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
